import { render } from "./MyNotification.vue?vue&type=template&id=59ecb989"
import script from "./MyNotification.vue?vue&type=script&lang=js"
export * from "./MyNotification.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__